import React, { useState } from "react";
import ChipView from "./Views/ChipView";
import ModalView from "./Views/ModalView";
import useCpAvailability from "./hooks";

const CpAvailabilityModal = () => {
  const { _onPress, modal, visible, chip } = useCpAvailability();

  const [open, setOpen] = useState(true);

  const {
    title,
    body,
    icon,
    cta_left_key: ctaLeftKey,
    cta_right_key: ctaRightKey,
    cta_left_text: ctaLeftText,
    cta_left_text_color: ctaLeftTextColor,
    cta_left_bg_color: ctaLeftBgColor,
    cta_right_text: ctaRightText,
    cta_right_text_color: ctaRightTextColor,
    cta_right_bg_color: ctaRightBgColor,
  } = modal || {};

  const {
    expanded_text: expandedText,
    expanded_text_color: expandedTextColor,
    expanded_bg_color: expandedBgColor,
    modal: chipModal,
  } = chip || {};

  return (
    <>
      <ChipView
        expandedBgColor={expandedBgColor}
        expandedText={expandedText}
        expandedTextColor={expandedTextColor}
        setOpen={setOpen}
        open={open}
        chipModal={chipModal}
      />
      <ModalView
        visible={visible}
        icon={icon}
        title={title}
        body={body}
        _onPress={_onPress}
        ctaLeftText={ctaLeftText}
        ctaRightBgColor={ctaRightBgColor}
        ctaRightText={ctaRightText}
        ctaLeftBgColor={ctaLeftBgColor}
        ctaLeftTextColor={ctaLeftTextColor}
        ctaRightTextColor={ctaRightTextColor}
        ctaLeftKey={ctaLeftKey}
        ctaRightKey={ctaRightKey}
      />
    </>
  );
};

export default CpAvailabilityModal;
